import { useFormikContext } from 'formik';
import OrganizationSetting from './Setting';
import { Switch } from '@mui/material';
import get from 'lodash/get';
import { OrganizationSettings } from '@/types';

interface Props {
  field: string;
  title: string;
  description: string;
  disabled?: boolean;
}

const SwitchSetting = ({ field, title, description, disabled = false }: Props) => {
  const { values, setFieldValue } = useFormikContext<OrganizationSettings>();

  return (
    <OrganizationSetting title={title} description={description}>
      <Switch
        disabled={disabled}
        checked={get(values, field, false)}
        onChange={(e: { target: { checked: boolean } }) => {
          setFieldValue(field, e.target.checked);
        }}
      />
    </OrganizationSetting>
  );
};

export default SwitchSetting;
